<template>
  <div class="project-mutate-shops">
    <Paywall
      :value="addons"
      :items="['project:shop']"
      :action="addon => $store.dispatch('Project/addon', { addon, state: true })"
      :options="{ units }"
    >
      <template #default>
        <Shops v-if="isActive" @submit.prevent="$emit('submit')" tag="form" />
      </template>
    </Paywall>
    <CustomFields
      v-model="value.customFields"
      :schema="customFieldSchemas"
      :data="data"
      :placement="['shops', 'project:shops']"
      :validator="validator"
      validator-prefix="customFields"
      :disabledFields="$path('metadata.disabledFields.project', item)"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { i18n } from '@/i18n'
import Store from '@/store'

import Shops from '@/components/Project/Shops'
import CustomFields from '@kvass/custom-fields'
import { Paywall } from '@/components/Upsell'

const meta = {
  order: 1004,
  id: 'shops',
  label: i18n.tc('addonShop', 2),
  icon: ['fal', 'fill-drip'],
}

export { meta }
export default {
  props: {
    data: Object,
    value: Object,
    isActive: Boolean,
    validator: Object,
    customFieldSchemas: { type: Array, default: () => [] },
  },
  computed: {
    ...mapState('Project', {
      item: 'item',
      addons(state) {
        return this.$path('item.metadata.addons', state) || []
      },
      units(state) {
        return this.$path('item.metadata.limits.units', state)
      },
    }),
  },

  components: {
    Paywall,
    CustomFields,
    Shops,
  },
}
</script>

<style lang="scss">
.project-mutate-shops .paywall__modules {
  top: 370px;
}
</style>
